var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"iconify svg--close text-xl",on:{"click":_vm.toggleNavigation}})}
var staticRenderFns = []

export { render, staticRenderFns }